export * from './AddRuleTypeParamLabel';
